import { Component, EventEmitter, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { ToasterService } from '../../providers/toaster/toaster.service';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-device-modal',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './device-modal.component.html',
  styleUrl: './device-modal.component.css'
})
export class DeviceModalComponent {
  @Output() closeModal = new EventEmitter<void>();
  isVisible: boolean = false;
  private apiUrl = environment.apiUrl;

  constructor(private http: HttpClient, private router: Router, private toasterService: ToasterService) {}

  openModal() {
    this.isVisible = true;
    setTimeout(() => {
      const modal = document.getElementById('deviceModal') as HTMLDialogElement;
      modal?.showModal();
    });
  }

  close() {
    const modal = document.getElementById('deviceModal') as HTMLDialogElement;
    modal?.close();
    this.isVisible = false;
    this.closeModal.emit();
  }

  private async getSystemDeviceId(): Promise<string> {
    const deviceFingerprint = [
      navigator.userAgent,
      navigator.language,
      navigator.platform,
      Intl.DateTimeFormat().resolvedOptions().timeZone,
      screen.width,
      screen.height,
      screen.colorDepth
    ].join('|');

    const encodedValue = new TextEncoder().encode(deviceFingerprint);
    const digest = await crypto.subtle.digest('SHA-256', encodedValue);

    return Array.from(new Uint8Array(digest))
      .map((byte) => byte.toString(16).padStart(2, '0'))
      .join('');
  }

  async onEnableDevice() {
    const authData = localStorage.getItem('auth_data');
    if (authData) {
      const { token, user } = JSON.parse(authData);
      const systemDeviceId = await this.getSystemDeviceId();
      const device = {
        id: systemDeviceId
      };
      const payload = {
        device_id: device.id,
        user_id: user?.id,
        status: true
      };

      this.http.post(`${this.apiUrl}device/register`, payload, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }).subscribe({
        next: (response: any) => {
          if (response.status === true) {
            // Set device_id in localStorage
            localStorage.setItem('device_id', response.device_id || device.id);

            this.toasterService.setToaster('success', 'Device Enabled', response.message);
            this.close();
            this.router.navigate(['/dashboard']);
          } else {
            this.toasterService.setToaster('error', 'Device Registration Failed', response.message || 'Something went wrong.');
          }
        },
        error: (error) => {
          this.toasterService.setToaster('error', 'Device Registration Failed', 'Something went wrong.');
        }
      });
    } else {
      this.toasterService.setToaster('error', 'Authentication Error', 'No authentication data found.');
    }
  }

  onCancel() {
    this.close();
  }
}